import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import App from './App';

Sentry.init({
  dsn: __CONFIG__.sentry.dsn,
  enabled: __CONFIG__.sentry.enabled,
  environment: __CONFIG__.sentry.environment,
  release: `${__CONFIG__.sentry.projectName}@${__VERSION__ || ''}`,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
